<template>
  <div id="scrollBody">
      <van-list
        class="scrollList"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="(item) of appointList" v-bind:key="item.SchoolAccessRecordID">
          <div class="box-body">
            <div>
              <h3 class="fl">{{item.CreateByDateName}}</h3>
              <p class="fr">{{item.AccessTypeName}}</p>
              <p style="clear:both"></p>
            </div>
            <div>
              <p class="fr">{{item.RecordTypeName}}：{{item.CreateByFullName}}</p>
              <p style="clear:both"></p>
            </div>
          </div>
        </van-cell>
      </van-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRefresh: false,
      finished: false,
      appointList: [],
      totalItems: 0,
      pageIndex: 0,
      pageSize: 15,
    };
  },
  created: function() {},

  mounted: function() {

  },

  methods: {
    async getList() {
      var params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      let res = await this.xyapi.get(this.$store.state.apiPath + '/api/SchoolAccessRecord/GetMyPageList', params);
      if (res.success) {
        // 加载状态结束
        this.isRefresh = false;
        if (res.data.data) {
          this.totalItems = res.data.totalRecords
          this.appointList = this.appointList.concat(res.data.data)
        } else {
          this.finished = true;
        }
        if (this.appointList.length >= this.totalItems) {
          this.finished = true;
        }
      }

    },
    onLoad(params = null) {
      this.pageIndex++
      params = Object.assign({pageIndex: this.pageIndex}, params);
      this.getList(params)
    },
  }
};
</script>

<style lang="less" scoped>
</style>
